import { useState } from "react";
import { useI18n } from "../../i18n/useI18n";
import Modal from "@/components/UI/Modal/Modal";
import Button from "@/components/UI/Button/Button";
import { useInactivateUser } from "../hooks/useInactivateUser";
import { Loader } from "./Loader";
import { toast } from "react-toastify";

interface DeleteUserProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  usernameDelete: string;
  refetch: () => void;
}

export const DeleteUser = ({ openModal, refetch, setOpenModal, usernameDelete }: DeleteUserProps) => {
  const { t } = useI18n();
  const [errorMessage, setErrorMessage] = useState("");
  const { mutateAsync, isPending } = useInactivateUser();

  const handleCloseModal = () => {
    setErrorMessage("");
    setOpenModal(false);
  };

  const handleInactivateUser = async () => {
    try {
      await mutateAsync(usernameDelete, {
        onSuccess: () => {
          toast.success("Usuario inactivado correctamente");
          refetch();
          handleCloseModal();
        },
        onError: (error) => {
          const defaultError = "Algo salió mal. Inténtalo de nuevo.";
          toast.error(error.message || defaultError);
          setErrorMessage(error.message || defaultError);
        },
      });
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
      toast.error("Ocurrió un error inesperado.");
    }
  }

  const modalFooter = (
    <>
      <Button variant="secondary" onClick={handleCloseModal}>
        {t("module_users.modal_create_button_cancel")}
      </Button>
      <Button variant="primary" onClick={handleInactivateUser} disabled={isPending}>
        {isPending ? t("module_users.modal_inactivating") : t("module_users.modal_inactivate_user_title")}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={openModal}
      onClose={handleCloseModal}
      title={t("module_users.modal_inactivate_user_title")}
      footer={modalFooter}
    >
      {isPending && <Loader />}
      <p>
        ¿Está seguro de que quiere inactivar al usuario: <strong>{usernameDelete}</strong>?
      </p>
      <p>
        Recuerde que si lo inactiva, siempre podrá volver a activarlo.
      </p>
      {errorMessage && (
        <p style={{ color: 'var(--color-danger)' }}>{errorMessage}</p>
      )}
    </Modal>
  )
}
